<template>
  <fragment>
    <v-col
      :cols="cols"
      :lg="lg"
      :md="md"
      :sm="sm"
      v-for="(item, index) in products"
      :key="index"
    >
      <v-hover v-slot="{ hover }">
        <div class="card-product" @click="openProductModal(item)">
          <v-img
            class="rounded-lg"
            :src="item.imagens.imagem1"
            height="200"
            :cover="hover"
          ></v-img>
          <v-expand-transition>
            <v-overlay
              v-if="hover"
              class="overlay-add d-flex transition-fast-in-fast-out v-card--reveal white--text"
            >
              <div class="d-flex flex-column justify-center align-center">
                <v-btn color="primary" fab small class="mb-2">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                <span class="font-weight-bold">
                  {{ $t("events.combos.add-event") }}
                </span>
              </div>
            </v-overlay>
          </v-expand-transition>
          <v-card-title class="text-body-1 font-weight-bold">
            <span class="description">
              {{ item.descricao }}
            </span>
          </v-card-title>
          <v-card-text>{{ item.preco | moeda }}</v-card-text>
        </div>
      </v-hover>
    </v-col>
    <modal-add-product :product="product" />
  </fragment>
</template>

<script>
import modalAddProduct from "@/components/produtos/combos/products/modalAddProduct.vue";
import { mapActions } from "vuex";
export default {
  name: "cardProducts",
  components: {
    modalAddProduct,
  },
  data: () => ({
    product: {},
  }),
  props: {
    products: Array,
    cols: Number,
    lg: Number,
    md: Number,
    sm: Number,
  },
  methods: {
    ...mapActions(["toggleProductAddModal"]),

    openProductModal(product) {
      this.product = product;
      this.toggleProductAddModal();
    },
  },
};
</script>
<style scoped>
.description {
  height: 50px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-product {
  max-height: 400px;
  border-radius: 16px;
  box-shadow: 11px 11px 22px #d9d9d9, -11px -11px 22px #ffffff;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease-in-out;
}
.card-product:hover {
  transform: scale(1.05);
  box-shadow: 11px 11px 12px #d9d9d9, -11px -11px 22px #ffffff;
}
.overlay-add {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}
</style>
